module.exports = __webpack_public_path__ + "img/edge_restauration_fait_maison.333a1dfa.svg";